"use client"
import { Slide } from '@/@types/Slide'
import React, { useState, useRef } from 'react'
import { FallbackImage } from '../common'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination } from 'swiper/modules'
import arrowRigth from "../../../public/images/icons/arrow-right-white.svg";
import 'swiper/css'
import 'swiper/css/pagination'
import { cn } from '@/lib/utils'
import Image from 'next/image'

type Props = {
  slides: Slide[]
}

export const Slider = ({ slides }: Props) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const swiperRef = useRef<any>(null)

  if (!slides || slides.length === 0) {
    return null
  }

  return (
    <section className="w-full relative group overflow-hidden">
      {slides.length > 1 ? (
        <>
          <button
            onClick={() => swiperRef.current?.slideTo(currentIndex - 1)}
            className="absolute left-1 md:left-8 top-1/2 -translate-y-1/2 z-10 bg-transparent p-3"
          >
            <Image
              className="rotate-180 opacity-55 hover:opacity-100"
              src={arrowRigth}
              alt="next Slide"
              width={15}
              height={15}
            />
          </button>

          <button
            onClick={() => swiperRef.current?.slideTo(currentIndex + 1)}
            className="absolute right-1 md:right-8 top-1/2 -translate-y-1/2 z-10 bg-transparent p-3"
          >
            <Image className="opacity-55 hover:opacity-100" src={arrowRigth} alt="next Slide" width={15} height={15} />
          </button>
        </>
      ) : (
        <></>
      )}

      <Swiper
        modules={[Autoplay, Pagination]}
        slidesPerView={1}
        onSlideChange={(swiper) => setCurrentIndex(swiper.activeIndex)}
        onSwiper={(swiper) => {
          swiperRef.current = swiper
        }}
        autoplay={{
          delay: 6000,
          disableOnInteraction: false,
        }}
        className="w-full"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <a
              href={slide.link}
              target={slide.is_blank == "1" ? "_blank" : "_self"}
              className='block w-full'
            >
              <div className="relative w-full pb-[62%] lg:pb-[20%]">
                {/* Imagen para móviles */}
                <div className="absolute inset-0 lg:hidden">
                  <FallbackImage
                    width={768}
                    height={384}
                    alt={slide.alt_text || 'Slider Image'}
                    src={slide.image_responsive}
                    className="w-full h-full object-cover"
                    priority={true}
                    sizes="100vw"
                  />
                </div>

                {/* Imagen para desktop */}
                <div className="absolute inset-0 hidden lg:block">
                    
                  <FallbackImage
                    width={1920}
                    height={384}
                    alt={slide.alt_text || 'Slider Image'}
                    src={slide.image}
                    className="w-full h-full object-cover"
                    priority={true}
                    sizes="100vw"
                  />
                </div>
              </div>
            </a>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Buttons */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2 z-10"> 
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => swiperRef.current?.slideTo(index)}
            className={cn(
              'w-5 h-5 rounded-full transition-all duration-500',
              index === currentIndex
                ? 'bg-white'
                : 'bg-white/50 hover:bg-white'
            )}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  )
}
